import React from "react";

import { useTranslation } from "react-i18next";
import { PlacesType, Tooltip } from "react-tooltip";

export function OfferHistoryPeriodTags(props: {
	eventId: string;
	isAfterExtraTime: boolean;
	isAfterPenalties: boolean;
	tagBlock: string;
	idPrefix: string;
	place?: PlacesType;
	openOnClick?: boolean;
	showFullText?: boolean;
}) {
	const { t } = useTranslation();
	const place = props.place ?? "right";

	return (
		<>
			<PeriodTag
				isVisible={props.isAfterExtraTime && !props.isAfterPenalties}
				blockClassName={`${props.tagBlock} ${props.tagBlock}--aet`}
				shortLabel={t("OFFER_HISTORY.AET")}
				fullText={t("OFFER_HISTORY.AFTER_EXTRA_TIME")}
				showFullText={props.showFullText}
				tooltipId={`${props.idPrefix}-aet-${props.eventId}`}
				place={place}
				openOnClick={props.openOnClick}
			/>
			<PeriodTag
				isVisible={props.isAfterPenalties}
				blockClassName={`${props.tagBlock} ${props.tagBlock}--ap`}
				shortLabel={t("OFFER_HISTORY.AP")}
				fullText={t("OFFER_HISTORY.AFTER_PENALTIES")}
				showFullText={props.showFullText}
				tooltipId={`${props.idPrefix}-ap-${props.eventId}`}
				place={place}
				openOnClick={props.openOnClick}
			/>
		</>
	);
}

function PeriodTag(props: {
	isVisible: boolean;
	blockClassName: string;
	shortLabel: string;
	fullText: string;
	showFullText?: boolean;
	tooltipId: string;
	place: PlacesType;
	openOnClick?: boolean;
}) {
	if (!props.isVisible) {
		return null;
	}

	if (props.showFullText) {
		return <span className={props.blockClassName}>{props.fullText}</span>;
	}

	return (
		<>
			<span
				className={`${props.blockClassName} tag tag--tny tag--bolder tag--ghost`}
				data-tooltip-id={props.tooltipId}
				data-tooltip-position-strategy="fixed"
			>
				{props.shortLabel}
			</span>
			<Tooltip
				id={props.tooltipId}
				className="react-tooltip--primary"
				place={props.place}
				openOnClick={props.openOnClick}
			>
				{props.fullText}
			</Tooltip>
		</>
	);
}
